import styled, { css } from 'styled-components';
import createComponentFromTagProp from 'react-create-component-from-tag-prop';
import { transparentize, darken, lighten } from 'polished';
import PropTypes from 'prop-types';
import { spaceOptions, spaceProps } from './utils';

const Types = ['primary', 'secondary', 'back', 'dark', 'outline', 'disable', 'snow', 'facebook'];

const propsToOmit = [
  ...Types,
  ...spaceProps,
  'theme',
  'block',
  'ghost',
  'small',
  'large',
  'extraLarge'
];

const getColorFromProps = props => {
  const validProps = Object.keys(props).filter(key => props[key]);
  return (
    props.theme[validProps.find(type => Object.keys(props).indexOf(type) > -1)] ||
    props.theme.primary
  );
};

export const Button = styled(
  createComponentFromTagProp({
    tag: 'button',
    propsToOmit
  })
)`
  ${base()};
  ${props => fallback(props)};
  ${props => paddingSet(props)};
  ${spaceOptions};
  ${props =>
    props.snow &&
    css`
      color: ${props.theme.bodyFont};
    `};
  ${props =>
    props.ghost &&
    css`
      color: ${getColorFromProps(props)};
      background: transparent;
      border: 1px solid ${getColorFromProps(props)};
      &:focus {
        background: transparent;
      }
      &:hover {
        color: ${transparentize(0.2, getColorFromProps(props))};
        background: ${transparentize(0.9, '#fff')};
      }
      &:active {
        background: transparent;
      }
    `};
  ${props =>
    props.small &&
    css`
      padding: 5px 20px;
    `};
  ${props =>
    props.large &&
    css`
      padding: 19px 60px;
    `};
  ${props =>
    props.extraLarge &&
    css`
      padding: 22px 80px;
    `};
  ${props =>
    props.block &&
    css`
      width: 100%;
      margin-bottom: 10px;
    `};
  ${props =>
    props['xs-block'] &&
    css`
      width: 100%;
      margin-bottom: 10px;
      @media (min-width: 30rem) {
        width: auto;
        margin-bottom: 0;
      }
    `};
`;

Button.displayName = 'Button';
Button.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  ghost: PropTypes.bool,
  small: PropTypes.bool,
  large: PropTypes.bool,
  extraLarge: PropTypes.bool,
  back: PropTypes.bool
};

Button.defaultProps = {
  theme: {}
};

function base() {
  return `
    text-decoration: none;
    display: inline-block;
    text-align: center;
    border-radius: 100px;
    font-size: 16px;
    cursor: pointer;
    appearance: none;
    outline: 0;
  `;
}

function fallback(props) {
  if (!props.ghost) {
    return `
      color: #fff;
      border: none;
      background: ${getColorFromProps(props)};

      &:focus {
        background: ${lighten(0.1, getColorFromProps(props))};
      }

      &:hover {
        color: none;
        border-color: ${transparentize(0.5, getColorFromProps(props))};
        background: ${transparentize(0.2, getColorFromProps(props))};
      }

      &:active {
        background: ${darken(0.2, getColorFromProps(props))};
      }
    `;
  }
}

function paddingSet(props) {
  if (props.small !== true && props.large !== true && props.extraLarge !== true) {
    return `padding: 12px 40px;`;
  }
}
